import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CatalogState } from "src/app/models/CatalogState";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: 'root' })

export class CatalogService {

  private catalogUrl = environment.catalogUrl;

  private httpOptions(session: string) {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + session
      }),
    };
  };

  constructor(private http: HttpClient) { }

  public addNewCatalog(technologyId: string, catalogName: string, importCatalogId: string): Observable<any> {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;

    let newCatalog;

    if (!importCatalogId || importCatalogId === "null") {
      newCatalog = {
        "name": catalogName,
        "technologyId": technologyId,
        "state": CatalogState.COMPLETE
      }
    }
    else {
      newCatalog = {
        "name": catalogName,
        "technologyId": technologyId,
        "state": CatalogState.COMPLETE,
        "importFromCatalogId": importCatalogId
      }
    }

    return this.http.post(this.catalogUrl + '/add', newCatalog, this.httpOptions(token));
  }

  public getAllCatalogs(): Observable<any> {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.get<any>(this.catalogUrl + "/all", this.httpOptions(token));
  }

  public myCatalogs(page: number = 0, size: number = 10, search: string = ''): Observable<any> {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    let url = this.catalogUrl + `/my?page=${page}&size=${size}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    return this.http.get<any>(url, this.httpOptions(token));
  }

  public getCatalogById(id: string): Observable<any> {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.get<any>(this.catalogUrl + "/" + encodeURIComponent(id), this.httpOptions(token));
  }

  public basicEditCatalog(catalogId: string, catalogName: string, technologyId: string, state: CatalogState): Observable<any> {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.put<any>(this.catalogUrl + '/' + encodeURIComponent(catalogId) + '/edit', {
      "name": catalogName,
      "technologyId": technologyId,
      "state": state
    }, this.httpOptions(token));
  }

  public getTechnologyFromCatalogId(id: string): Observable<any> {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.get<any>(this.catalogUrl + "/" + encodeURIComponent(id) + "/technology", this.httpOptions(token));
  }

  public getUsersFromCatalogId(id: string): Observable<any> {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.get<any>(this.catalogUrl + "/" + encodeURIComponent(id) + "/users", this.httpOptions(token));
  }

  public isCatalogUsed(catalogID: any): Observable<any> {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.get<any>(this.catalogUrl + "/isItUsed/" + encodeURIComponent(catalogID), this.httpOptions(token));
  }
}
